import React from "react"
import { About } from "../components/About"

const AboutPage = () => <About />

export default AboutPage
